export enum LinkType {
	PowerRankings   = 0,
	PlayoffMachine  = 1,
	PlayoffOdds     = 2,
	Scheduler       = 3,
	LeagueHistory = 4,
	TradeHistory = 5,
	PlayoffTool = 6
}